export default __webpack_public_path__ + "static/media/vol1_1.ad89fd16.png";